module.exports = __webpack_public_path__ + "static/favicon-f06c210189a6b790e8c166bd2e9b5fe0.ico";